import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { ComponentProps, JSX } from 'react';
import { cn } from '@/lib/utils';

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export function TooltipContent({ className, sideOffset = 6, ...props }: ComponentProps<typeof TooltipPrimitive.Content>): JSX.Element {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn('z-50 rounded-md bg-hce-ink px-2.5 py-1.5 text-xs text-hce-paper shadow-md', className)}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
}
